import Sensual90 from '@mui/icons-material/HistoryToggleOff';
import { Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import formatSchedule from '../utils/formatSchedule';
import techniqueChecker from '../utils/techniqueChecker';
import AvailabilityButton from './AvailabilityButton';
import FeedbackSlider from './FeedbackSlider';
import Gallery from './Gallery';

const MasseuseContainerDesktop = ({ masseuse, slots, available_on }) => {
  return (
    <Grid
      container
      key={masseuse.id}
      className="masseuse-container"
      style={{ backgroundColor: masseuse.vacation && 'rgba(212,160, 54,0.3)' }}
    >
      {masseuse.vacation && (
        <Grid item xs={12}>
          <Typography
            variant="h6"
            component="div"
            className="masseuse-vacation-title"
            style={{
              fontWeight: '800',
              marginTop: '20px',
              marginBottom: '-40px',
              color: '#c3892b',
            }}
          >
            RETURNING SOON
          </Typography>
        </Grid>
      )}
      <Grid
        item
        xs={12}
        sm={6}
        order={{ xs: 2, sm: 1, md: 1, lg: 1 }}
        className="masseuse-info-container"
      >
        <h3 className="masseuse-desktop-name">
          Name:{' '}
          <span className="masseuse-name-span">
            {masseuse.name}{' '}
            {masseuse.new && (
              <Tooltip title="New masseuse">
                <img
                  src="https://clubdynasty.ca/wp-content/uploads/2022/01/new-purple-animation.gif"
                  width="30"
                  alt="New Masseuse"
                ></img>
              </Tooltip>
            )}{' '}
            {masseuse.foot_massage && (
              <Tooltip title="Available for foot massages">
                <img
                  src="https://clubdynasty.ca/wp-content/uploads/2022/11/foot_massage.gif"
                  width="30"
                  alt="Foot Massage"
                ></img>
              </Tooltip>
            )}
            {masseuse.allow_lingam && (
              <Tooltip title="Available for lingam massages">
                <img
                  src="https://clubdynasty.ca/wp-content/uploads/2024/07/lingam_icon.gif"
                  width="30"
                  alt="Foot Massage"
                ></img>
              </Tooltip>
            )}{' '}
            {masseuse.sensual90 && (
              <Tooltip title="Available for 90-minute massages">
                <Sensual90 sx={{ color: 'rgb(255, 140, 26)' }} />
              </Tooltip>
            )}
          </span>
        </h3>

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Age:{' '}
            <span className="masseuse-details-span">
              {masseuse.age ? masseuse.age : 'Not available'}
            </span>
          </h4>
        )}

        <h4 className="masseuse-details">
          Background:{' '}
          <span className="masseuse-details-span">
            {masseuse.background ? masseuse.background : 'Not available'}
          </span>
        </h4>
        <h4 className="masseuse-details">
          Language:{' '}
          <span className="masseuse-details-span">
            {masseuse.language ? masseuse.language : 'Not available'}
          </span>
        </h4>

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Clientele:{' '}
            <span className="masseuse-details-span">
              {masseuse.services ? masseuse.services : 'Not available'}
            </span>
          </h4>
        )}

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Tattoos:{' '}
            <span className="masseuse-details-span">
              {masseuse.tattoos ? 'Yes' : 'No'}
            </span>
          </h4>
        )}

        <h4 className="masseuse-details">
          Height:{' '}
          <span className="masseuse-details-span">
            {masseuse.height ? masseuse.height : 'Not available'}
          </span>
        </h4>

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Measurements:{' '}
            <span className="masseuse-details-span">
              {masseuse.measurements ? masseuse.measurements : 'Not available'}
            </span>
          </h4>
        )}

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Interests:{' '}
            <span className="masseuse-details-span">
              {masseuse.interests ? masseuse.interests : 'Not available'}
            </span>
          </h4>
        )}

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Bust:{' '}
            <span className="masseuse-details-span">
              {masseuse?.bust_enhanced ? 'Enhanced' : 'Natural'}
            </span>
          </h4>
        )}

        {techniqueChecker(masseuse.technique) && (
          <h4 className="masseuse-details">
            Hair Color:{' '}
            <span className="masseuse-details-span">
              {masseuse?.hair_color.length === 0
                ? 'Not Available'
                : masseuse.hair_color}
            </span>
          </h4>
        )}

        <h4 className="masseuse-details">
          Bio:{' '}
          <span className="masseuse-details-span">
            {masseuse.bio ? masseuse.bio : 'Not available'}
          </span>
        </h4>

        <h4 className="masseuse-details">
          Schedule:{' '}
          {masseuse.schedule.length ? (
            masseuse.schedule.map((s) => (
              <span className="masseuse-details-span" key={s.id}>
                <br />
                {formatSchedule(s)}
              </span>
            ))
          ) : (
            <span className="masseuse-details-span">
              <br />
              Not Available
            </span>
          )}
        </h4>

        <h4 className="masseuse-details">Customer Feedback:</h4>
        <FeedbackSlider masseuseId={masseuse.id} />
      </Grid>

      <Grid
        item
        xs={12}
        sm={6}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        order={{ xs: 1, sm: 2, md: 2, lg: 2 }}
      >
        {(techniqueChecker(masseuse.technique) ||
          masseuse.name === 'Crystal') &&
          (!masseuse?.images || masseuse?.images?.length < 1 ? (
            <img
              src={masseuse?.image}
              className="masseuse-image"
              alt={masseuse?.name}
            />
          ) : (
            <Gallery
              images={[masseuse.image, ...masseuse.images]}
              thumbnails={[masseuse.image, ...masseuse.newThumbnails]}
            />
          ))}
        {masseuse.technique === 'Shiatsu' && masseuse.name !== 'Crystal' && (
          <img
            src={
              'https://clubdynasty.ca/wp-content/uploads/2023/01/Female_Silouhette-scaled.jpg'
            }
            className="masseuse-image"
            alt={masseuse?.name}
          />
        )}

        <AvailabilityButton
          masseuse={masseuse}
          slots={slots}
          available_on={available_on}
        />
      </Grid>
    </Grid>
  );
};

export default MasseuseContainerDesktop;
